import { configureStore } from "@reduxjs/toolkit";
import presenceReducer from "src/store/presenceSlice";
import themeReducer from "src/store/themeSlice";
import authReducer from "src/store/authSlice";

const store = configureStore({
  reducer: {
    presence: presenceReducer,
    theme: themeReducer,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
